<script setup lang="ts">
import VButton from '@components/buttons/VButton/VButton.vue';
import VLoader from '@components/loader/VLoader.vue';
import {
  ADMIN_ARTICLES_LIST_ROUTE_NAME,
  AFFILIATE_ARTICLES_LIST_ROUTE_NAME,
} from '@modules/articles/constants';
import { useFormatDate } from '@modules/core/composables/datetime';
import { useDashboardArticlesQuery } from '@modules/dashboard/queries';
import { useCurrentNamespace } from '@modules/permissions/composables';

import { TRANSLATION_GROUP_DASHBOARD_AFFILIATE } from '../../constants';

const { data: articles, isLoading } = useDashboardArticlesQuery();

const { isAdminNamespace } = useCurrentNamespace();
const { formatDate } = useFormatDate();
</script>

<template>
  <PCard v-data-qa-auto-id="'TheDashboardArticles'">
    <template #title>
      <div>{{ $getTranslation(TRANSLATION_GROUP_DASHBOARD_AFFILIATE, 'LAST_ARTICLES_TITLE') }}</div>
    </template>
    <template #content>
      <VLoader :loading="isLoading">
        <div v-if="articles?.length">
          <div
            v-for="item in articles"
            :key="item.id"
            class="flex justify-between border-b border-b-gray-200 px-0 py-3"
          >
            <span>{{ item.title }}</span>
            <span class="text-muted-color">{{ formatDate(item.created_at, 'PPp') }}</span>
          </div>
        </div>
        <div
          v-else
          class="flex min-h-[100px] items-center justify-center"
        >
          <div>
            {{ $getTranslation(TRANSLATION_GROUP_DASHBOARD_AFFILIATE, 'LAST_ARTICLES_NO_ARTICLES') }}
          </div>
        </div>
      </VLoader>
    </template>
    <template #footer>
      <VButton
        :to="{ name: isAdminNamespace ? ADMIN_ARTICLES_LIST_ROUTE_NAME : AFFILIATE_ARTICLES_LIST_ROUTE_NAME }"
        :label="$getTranslation(TRANSLATION_GROUP_DASHBOARD_AFFILIATE, 'LAST_ARTICLES_SEE_MORE')"
      />
    </template>
  </PCard>
</template>
